import React from 'react';
import './Collection.css';
import { ROOT_IMG_URL } from '../../GlobalValues';
import Carrousel from '../Carrousel/Carrousel';

const Collection = ({ carouStyle = {}, style = {} }) => {
  const images = ['collection1.png'];

  return (
    <CollectionWrapper style={style}>
      <Carrousel
        items={images}
        style={{ maxHeight: '600px', width: '100%', ...carouStyle }}
      >
        {(image, index) => (
          <img
            src={`${ROOT_IMG_URL}/${image}`}
            alt={`Collection ${index + 1}`}
            className="sl-carrou-cover"
            width={880}
            height={400}
            loading="lazy"
            decoding="async"
          />
        )}
      </Carrousel>
    </CollectionWrapper>
  );
};

const CollectionWrapper = ({ children, style = {} }) => {
  return (
    <section
      className="collection-section"
      style={style}
      aria-label="Notre collection de coiffures"
    >
      <div className="collection-title sl-title-bloc sl-title">
        <h3>NOTRE COLLECTION</h3>
      </div>
      <div style={{ width: '100%' }}>{children}</div>
    </section>
  );
};

export { Collection, CollectionWrapper };
